import { TiktokInfluencerProfile, TiktokInfluencers } from '@anytag/shared-organisms';
import { InfluencersTabType } from '@anytag/shared-types';
import { useSocialAccountSelectButtonProps } from './hooks';

export const TiktokInfluencersSearch = () => {
  const { getSortSelectButtonProps, getListSelectButtonProps } =
    useSocialAccountSelectButtonProps<TiktokInfluencerProfile>({
      socialMedia: InfluencersTabType.TIKTOK
    });

  return (
    <TiktokInfluencers
      getSortSelectButtonProps={getSortSelectButtonProps}
      getListSelectButtonProps={getListSelectButtonProps}
    />
  );
};
